// @ts-ignore
/* eslint-disable */
import { request } from '../../../utils/request';

/** 读取运营主体声明配置 GET /legal-disclosure */
export async function getConfig(options?: { [key: string]: any }) {
  return request<API.LegalDisclosureConfig>('/legal-disclosure', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 读取运营主体声明历史 GET /legal-disclosure/history */
export async function getHistory(options?: { [key: string]: any }) {
  return request<API.LegalDisclosureRevision[]>('/legal-disclosure/history', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 保存运营主体声明草稿 POST /legal-disclosure/draft */
export async function saveDraft(
  body: API.LegalDisclosureDraftMutationForm,
  options?: { [key: string]: any },
) {
  return request<API.LegalDisclosureConfig>('/legal-disclosure/draft', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 发布运营主体声明 POST /legal-disclosure/publish */
export async function publish(
  body: API.LegalDisclosureDraftMutationForm,
  options?: { [key: string]: any },
) {
  return request<API.LegalDisclosureConfig>('/legal-disclosure/publish', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 回滚到指定发布版本 POST /legal-disclosure/rollback/${revisionId} */
export async function rollback(
  params: API.rollbackParams,
  body: API.LegalDisclosureRollbackForm,
  options?: { [key: string]: any },
) {
  const { revisionId, ...queryParams } = params;
  return request<API.LegalDisclosureConfig>(
    `/legal-disclosure/rollback/${revisionId}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    },
  );
}
